module.exports = __webpack_public_path__ + "static/img/24.35adcf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/24.jpg
// module id = /tkK
// module chunks = 0